module.exports = __webpack_public_path__ + "static/6-1bc34999552f4fa15c45200546a94398.svg";